import React, { FC, Fragment, useState } from 'react';
import { useQuery } from '@apollo/client';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';
import { pandaStatusVar } from 'apollo/reactive-variables/scan-case';
import { Alert, Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from 'config/constants';
import { pandaStatusTemplate } from 'apollo/templates/scanner-case';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';
import { ScannerCaseAuthStatus } from 'models/scanner-case';

const PandaAuthContainer: FC = () => {
    const { t: translate } = useTranslation(['scan-cases']);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [pandaAuthUrl, setPandaAuthUrl] = useState('');
    const pandaFrontendStatus = pandaStatusVar();
    const { showBoundary } = useDenthubErrorBoundary();
    const isCurrentlyAuthorizing = window.location.href.includes('panda-auth-callback');

    useQuery(pandaStatusTemplate, {
        onCompleted: ({ pandaStatus }: { pandaStatus: ScannerCaseAuthStatus }) => {
            pandaStatusVar(pandaStatus);
            if (pandaStatus.enabled && !pandaStatus.authorized && !isCurrentlyAuthorizing) {
                const randomValue = new Date().getTime();
                const pandaReturnUrl = `/en/connect/authorize/callback?client_id=${pandaStatus.clientId}&response_type=code&scope=openid profile api.resource.full offline_access&redirect_uri=${CONSTANTS.PANDA_AUTH_REDIRECT}&client_secret=${pandaStatus.clientSecret}&state=${randomValue}&nonce=${randomValue}&code_challenge=${pandaStatus.codeChallenge}&code_challenge_method=S256`;
                setPandaAuthUrl(
                    `${CONSTANTS.PANDA_AUTH_URL}/en/Account/Login?ReturnUrl=${encodeURIComponent(pandaReturnUrl)}`,
                );
                setDialogOpen(true);
            }
        },
        onError(error) {
            showBoundary(error);
        },
    });

    const onDialogClose = () => {
        setDialogOpen(false);
    };

    return (
        <Fragment>
            {pandaFrontendStatus.enabled ? (
                <DHDialog
                    fullWidth
                    maxWidth="sm"
                    open={dialogOpen}
                    onClose={onDialogClose}
                    title={`${translate('scan-cases:YOU_NEED_TO_LOGIN_TO_PANDA')} (EN Region)`}
                >
                    <Alert severity="info" sx={{ whiteSpace: 'pre-wrap' }}>
                        {translate('scan-cases:PANDA_LOGIN_DESC')}
                    </Alert>
                    <Box mt={2} sx={{ textAlign: 'center' }}>
                        <Button variant="contained" href={pandaAuthUrl}>
                            {translate('scan-cases:LOGIN_TO_PANDA')} (EN Region)
                        </Button>
                    </Box>
                </DHDialog>
            ) : undefined}
        </Fragment>
    );
};

export default PandaAuthContainer;
